import { organizationIsSupplemental } from '@/components/refRepsPortal/portalOrganization.js'

export const PACK_REQUIRES_COURSE_SPORT_MESSAGE =
  'Assign the matching educational course for this sport before assigning this supplemental POV pack.'

/** Course-license orgs require a matching sport course before a POV pack can be assigned. */
export function organizationEnforcesPackCoursePrerequisite(org) {
  if (!org) return false
  return !organizationIsSupplemental(org)
}

export function studentHasAssignedCourseForSport(student, sport, coursesCatalog = []) {
  if (!student || !sport) return false
  const courseIds = new Set((student.courseIds || []).map((id) => String(id)))
  return (coursesCatalog || []).some(
    (course) =>
      course.type === 'course' &&
      course.sport === sport &&
      courseIds.has(String(course.id))
  )
}

export function canAssignPackToStudent(student, pack, org, coursesCatalog = []) {
  if (!pack || pack.type !== 'pov') return true
  if (!organizationEnforcesPackCoursePrerequisite(org)) return true
  return studentHasAssignedCourseForSport(student, pack.sport, coursesCatalog)
}

export function packPrerequisiteMessageForSport(sport) {
  if (!sport) return PACK_REQUIRES_COURSE_SPORT_MESSAGE
  return `Assign the ${sport} educational course to this learner first.`
}

/**
 * Whether assigning this catalog item consumes an org seat.
 * Courses: when `shouldTakeSeats` is true.
 * POV packs: only on supplemental orgs (Supp. Basic / Supp. Premium).
 *
 * @param {Record<string, unknown> | null | undefined} org
 * @param {{ type?: string, shouldTakeSeats?: boolean } | null | undefined} content
 */
export function assignmentConsumesOrganizationSeat(org, content) {
  if (!content || typeof content !== 'object') return false
  if (content.type === 'course') {
    return content.shouldTakeSeats === true
  }
  if (content.type === 'pov') {
    return organizationIsSupplemental(org)
  }
  return false
}

/** @param {Record<string, unknown> | null | undefined} org @param {{ type?: string, shouldTakeSeats?: boolean } | null | undefined} content */
export function organizationLacksSeatsForAssignment(org, content) {
  return assignmentConsumesOrganizationSeat(org, content) && Number(org?.seats ?? 0) <= 0
}

/**
 * @param {Record<string, unknown> | null | undefined} org
 * @param {{ type?: string, shouldTakeSeats?: boolean } | null | undefined} content
 * @param {number} delta Positive to return seats, negative to consume.
 */
export function adjustOrganizationSeatsForAssignment(org, content, delta) {
  if (!org || !assignmentConsumesOrganizationSeat(org, content)) return
  const change = Number(delta) || 0
  if (!change) return
  org.seats = Math.max(0, Number(org.seats ?? 0) + change)
}
